import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=cb4ce062&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4ce062",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb4ce062')) {
      api.createRecord('cb4ce062', component.options)
    } else {
      api.reload('cb4ce062', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=cb4ce062&scoped=true&", function () {
      api.rerender('cb4ce062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PgC415szXlrN/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports